import { render } from "./IndonesiaInfo.vue.ts?vue&type=template&id=e12bc65d&scoped=true&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IndonesiaInfo.vue?vue&type=template&id=e12bc65d&scoped=true&ts=true"
import script from "./IndonesiaInfo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IndonesiaInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndonesiaInfo.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IndonesiaInfo.vue?vue&type=script&setup=true&lang=ts"

import "./IndonesiaInfo.vue.scss?vue&type=style&index=0&id=e12bc65d&lang=scss&scoped=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IndonesiaInfo.vue?vue&type=style&index=0&id=e12bc65d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e12bc65d"],['__file',"src/apps/merchant3/components/customer-registration/customer-contact-info/countries-extra-info/IndonesiaInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e12bc65d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e12bc65d', __exports__)) {
    api.reload('e12bc65d', __exports__)
  }
  
  module.hot.accept("./IndonesiaInfo.vue.ts?vue&type=template&id=e12bc65d&scoped=true&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IndonesiaInfo.vue?vue&type=template&id=e12bc65d&scoped=true&ts=true", () => {
    api.rerender('e12bc65d', render)
  })

}


export default __exports__